<template>
    <div class="app-layout">
        <Header />
        <FloatingQuickMenu v-if="!route.meta.hideFloatingQuickMenu" />
        <main>
            <router-view v-slot="{ Component, route: viewRoute }">
                <component :is="Component" :key="routeViewKey(viewRoute)" />
            </router-view>
        </main>
        <Footer v-if="!route.meta.hideFooter" :footerText="footerText" :show-info-cards="route.path === '/'" />

    </div>
</template>

<script setup>
import { ref, onMounted, provide } from 'vue'
import { useRoute } from 'vue-router'
import Header from '@/components/header.vue'
import FloatingQuickMenu from '@/components/FloatingQuickMenu.vue'
import Footer from '@/components/Footer.vue'
import { useUserStore } from '@/stores/user'

const route = useRoute()
// 页面内的 PageTitle 渲染到 header 的面包屑行
provide('headerBreadcrumb', true)

// delivery-application 需要随查询参数整体重建；
// 使用指南详情页在文章之间切换时复用页面实例（组件内部已监听 route.params.id），
// 避免整页重建导致左侧菜单重新加载而闪烁。
const routeViewKey = (r) => {
    if (r.path === '/delivery-application') return r.fullPath
    if (r.matched.some(record => record.path === '/guide/:id')) return '/guide/detail'
    return r.path
}

const footerText = ref(`
  <strong>차이나원</strong><br />
  사업자등록번호 : 312-79-00423  ㅣ 대표 : 이철홍<br />
  사업장주소 : 인천광역시 서구 북항로 140 (원창동)<br />
  통신판매업신고번호 : 2024-인천서구-2921호 ㅣ 개인정보책임자 : 이철홍<br />    
  제휴 문의: 070-8878-1239<br />
  메일: chinaonekr@naver.com<br />
  © 2000 -. All Rights Reserved.<br />
`)
onMounted(() => {

})
</script>

<style scoped>
.app-layout {
    display: flex;
    min-height: 100vh;
    flex-direction: column;
}

.app-layout > main {
    flex: 1 0 auto;
}
</style>
